module.exports = __webpack_public_path__ + "static/media/profileActive.bc0cce5e.svg";